import { useState } from "react";
import { PageShell, PageHero } from "@project/user/components/page-shell";
import { Reveal } from "@project/user/components/motion";
import { AdmissionSuccessDialog } from "@project/user/components/admission-success-dialog";
import { AdmissionApplicationForm } from "@project/components/admission-application-form";
import { useI18n } from "@project/lib/use-i18n";

export default function ApplyAdmissionPage() {
  const { t } = useI18n();
  const [successOpen, setSuccessOpen] = useState(false);
  const [submittedSummary, setSubmittedSummary] = useState<{
    applicantName: string;
    elderName: string;
  } | null>(null);

  const handleSuccessOpenChange = (open: boolean) => {
    setSuccessOpen(open);
    if (!open) {
      setSubmittedSummary(null);
    }
  };

  return (
    <PageShell>
      <AdmissionSuccessDialog
        open={successOpen}
        onOpenChange={handleSuccessOpenChange}
        applicantName={submittedSummary?.applicantName}
        elderName={submittedSummary?.elderName}
      />
      <PageHero
        eyebrow={t("account.applyAdmission.eyebrow")}
        title={t("account.applyAdmission.title")}
        subtitle={t("account.applyAdmission.subtitle")}
      />
      <section className="mx-auto max-w-4xl px-4 py-8 sm:py-12">
        <Reveal variant="morph">
          <div className="anim-fade-up" style={{ animationDelay: "200ms" }}>
            <AdmissionApplicationForm
              mode="user"
              onSubmitted={summary => {
                setSubmittedSummary(summary);
                setSuccessOpen(true);
              }}
            />
          </div>
        </Reveal>
      </section>
    </PageShell>
  );
}
